import { useScrollReveal } from '@/hooks/useScrollReveal';
import { investmentBenefits } from '@/mocks/landingData';

export default function InvestmentBenefits() {
  useScrollReveal('.investment-reveal', 0.1);

  return (
    <section id="investment" className="py-20 md:py-28 lg:py-32 bg-charcoal relative overflow-hidden">
      {/* Background Glow Effects */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gold/5 rounded-full blur-[100px]" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-gold/5 rounded-full blur-[80px]" />

      <div className="section-padding relative z-10">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-20">
          <div className="investment-reveal scroll-reveal">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 rounded-full font-body text-xs tracking-[0.2em] uppercase text-white/70">
              <span className="w-2 h-2 bg-gold rounded-full" />
              Investment Advantage
            </span>
          </div>
          <h2 className="investment-reveal scroll-reveal font-display text-3xl md:text-4xl lg:text-5xl text-white font-bold mt-6 leading-tight">
            Why Investors Choose
            <br />
            <span className="text-gold">Confident Auriga</span>
          </h2>
          <p className="investment-reveal scroll-reveal font-body text-base md:text-lg text-white/60 mt-6 leading-relaxed">
            Beyond a home, Confident Auriga represents a strategic asset positioned for exceptional long-term returns in Karnataka's most promising growth corridor.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {investmentBenefits.map((benefit, index) => (
            <div
              key={benefit.title}
              className="investment-reveal scroll-reveal group relative bg-white/5 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/10 hover:border-gold/40 transition-all duration-500 hover:bg-white/10"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              {/* Glow Effect on Hover */}
              <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 gold-glow" />

              <div className="relative z-10">
                <div className="w-14 h-14 rounded-xl bg-gold/10 flex items-center justify-center mb-6 group-hover:bg-gold/20 transition-colors duration-300">
                  <i className={`${benefit.icon} text-gold text-2xl`}></i>
                </div>
                <h3 className="font-display text-lg md:text-xl text-white font-semibold mb-3">{benefit.title}</h3>
                <p className="font-body text-sm text-white/60 leading-relaxed">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Stats Bar */}
        <div className="investment-reveal scroll-reveal mt-16 md:mt-20 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {[
            { label: 'Project Area', value: '90 Acres' },
            { label: 'Total Plots', value: '1100+' },
            { label: 'Starting Price', value: 'On Request' },
            { label: 'Possession', value: 'Immediate' },
          ].map((stat) => (
            <div key={stat.label} className="text-center py-6 border border-white/10 rounded-xl bg-white/5 backdrop-blur-sm">
              <div className="font-display text-xl md:text-2xl text-gold font-bold mb-1">{stat.value}</div>
              <div className="font-body text-xs text-white/50 tracking-wider uppercase">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}